export default "__VITE_ASSET__DL7p6pTM__"